<template>
  <ul class="type-list">
    <li v-for="(area, index) in areaList" :key="index" class="region">
      <nuxt-link :to="url(area)">
        {{ area }}のセミナー会場がある路線
      </nuxt-link>
    </li>
  </ul>
</template>

<script>
import { config } from '@/utils/config'
import { createUrl } from '@/utils/create-url'
export default {
  computed: {
    areaList() {
      return config.searchArea.map((area) => {
        return area.name
      })
    }
  },
  methods: {
    url(area) {
      return createUrl.createAreaStationUrl(area)
    }
  }
}
</script>
